<template>
  <div id="editLibraryItemWrapper">
    <template v-if="type">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Naam</label>

            <div class="control">
              <input
                class="input"
                type="text"
                name="name"
                :value="item.name"
                @change="set('name', $event.target.value)"
              >
            </div>
          </div>

          <edit-library-text v-if="type === 'App\\LibraryText'" />

          <edit-library-link
            v-else-if="type === 'App\\LibraryLink'"
            :item="item.contentable"
          />

          <edit-library-file
            v-else-if="type === 'App\\LibraryFile'"
            :item="item.contentable"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field is-grouped">
            <p class="control">
              <button
                  class="button is-link"
                  @click="save"
              >
                Opslaan
              </button>
            </p>

            <p class="control">
              <button
                  class="button is-outlined"
                  @click="cancel"
              >
                Annuleren
              </button>
            </p>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="columns">
        <div class="column is-offset-one-third is-one-third">
          <div
            v-for="(type, idx) in types"
            :key="idx"
            class="field"
          >
            <p class="control">
              <button
                class="button is-info is-fullwidth"
                @click="setType(type.type)"
              >
                {{ type.caption }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditLibraryText from '@/components/library/EditLibraryText'
import EditLibraryLink from '@/components/library/EditLibraryLink'
import EditLibraryFile from '@/components/library/EditLibraryFile'

export default {
  name: 'EditLibraryItem',

  components: {
    EditLibraryLink,
    EditLibraryText,
    EditLibraryFile,
  },

  computed: {
    ...mapGetters({
      item: 'library/item'
    })
  },

  data() {
    return {
      type: null,

      types: [
        {
          'type': 'App\\LibraryText',
          'caption': 'Tekst',
        },
        {
          'type': 'App\\LibraryLink',
          'caption': 'Link',
        },
        {
          'type': 'App\\LibraryFile',
          'caption': 'Bestand',
        },
      ]
    }
  },

  created() {
    if (this.$attrs.id) {
      this.$store.dispatch('library/load', this.$attrs.id)
    }
  },

  watch: {
    item() {
      if (this.item) {
        this.type = this.item.contentable_type
      }
    }
  },

  methods: {
    set(key, value) {
      this.$store.commit('library/SET', { key, value })
    },

    save () {
      this.$store.dispatch('library/save', this.item)
    },

    cancel () {
      this.$store.commit('library/SET_ITEM', {})
      this.$router.go(-1)
    },

    setType (type) {
      this.$store.commit('library/SET_TYPE', type)
      this.type = type
    }
  }
}
</script>

<style scoped>

</style>
